<template>
  <div class="m">
    <NavBar />
    <div class="m-main">
      <div v-if="active==='zyfz'">
        <h4 class="page-header">{{ $t('mobile.careerDevelopment') }}</h4>
        <ul class="menu-list">
          <li @click="open('/m/article/qzgh')">{{ $t('mobile.careerInsights') }}</li>
          <li @click="open('/m/article/event')">{{ $t('mobile.latestEvents') }}</li>
          <li @click="open('/m/article/sxhjyjh')">{{ $t('mobile.careerOpportunities') }}</li>
          <li @click="open('/m/careerProgrammes')">{{ $t('mobile.careerProgrammes') }}</li>
        </ul>
      </div>
      <div v-if="active==='tlr'">
        <h4 class="page-header">{{ $t('mobile.peerSharing') }}</h4>
        <ul class="menu-list">
          <li @click="open('/m/article/xygs')">{{ $t('mobile.peerStories') }}</li>
          <li @click="open('https://mp.weixin.qq.com/s/8nFRDkvQk5JvfkkSwf-A_w')">{{ $t('mobile.highlightMoments') }}</li>
          <li @click="open('/m/article/xyds')">{{ $t('mobile.campusAmbassador') }}</li>
          <li @click="open('https://mp.weixin.qq.com/s/EZUOva0mI1KO93bwMSyQWg')">{{ $t('mobile.callForLetters') }}</li>
          <li @click="open('/m/article/tzy')">{{ $t('mobile.internshipChallenge') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import NavBar from './NavBar'
export default {
  components: {
    NavBar
  },
  data() {
    return {
      active: ''
    }
  },
  watch: {
    '$route': {
      handler(val) {
        const { cat } = val.params
        this.active = cat
      }
    }
  },
  mounted() {
    this.active = this.$route.params.cat
    console.log(this.active)
  },
  methods: {
    open(path) {
      if (path) {
        path.startsWith('http') ? window.open(path, '_self') : this.$router.push(path)
      }
    }
  }
}
</script>

<style>
.menu-list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.menu-list li {
    position: relative;
    margin-bottom: .3rem;
    padding: .6rem .4rem;
    color: #111;
    font-size: .36rem;
    border-radius: .08rem;
}
.menu-list li:nth-child(5n+1) {
    background-image: linear-gradient(rgba(208, 74, 2,.8), rgba(208, 74, 2,.4));
}
.menu-list li:nth-child(5n+2) {
    background-image: linear-gradient(rgba(217, 57, 84,.8), rgba(217, 57, 84,.4));
}
.menu-list li:nth-child(5n+3) {
    background-image: linear-gradient(rgba(224, 48, 30,.8), rgba(224, 48, 30,.4));
}
.menu-list li:nth-child(5n+4) {
    background-image: linear-gradient(rgba(255, 182, 0,.8), rgba(255, 182, 0,.4));
}
.menu-list li:nth-child(5n+5) {
    background-image: linear-gradient(rgba(235, 140, 0,.8), rgba(235, 140, 0,.4));
}
.menu-list li::after {
    position: absolute;
    right: 0;
    top: 0;
    width: 3rem;
    height: 100%;
    background: url(./../../assets/m/menu-list-img.png) right 0 no-repeat;
    background-size: auto 500%;
    content: "";
}
.menu-list li:nth-child(5n+1)::after {
    background-position: right 0;
}
.menu-list li:nth-child(5n+2)::after {
    background-position: right 25%;
}
.menu-list li:nth-child(5n+3)::after {
    background-position: right 50%;
}
.menu-list li:nth-child(5n+4)::after {
    background-position: right 75%;
}
.menu-list li:nth-child(5n+5)::after {
    background-position: right 100%;
}
</style>
